// @ts-ignore
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
  IconButton,
  Chip,
  SelectChangeEvent,
  Autocomplete,
  CircularProgress,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { Helper } from '../../tools/Helper';
import { api_Routes } from "../../tools/api_Routes.js";
import {useNavigate} from "react-router-dom";

interface StartNewConversationDialogProps {
  open: boolean;
  onClose: () => void;
  onGroupCreated: () => void;
  setSelectedConversation: () => void;
}

interface User {
  id: number;
  name: string;
  avatar?: string;
}

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export const StartNewConversationDialog: React.FC<StartNewConversationDialogProps> = ({
  open,
  onClose,
  onGroupCreated,
  setSelectedConversation,
}) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: null,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');


  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const formDataToSend = new FormData();

      
      // Send members as an array of IDs
      // formData.members.forEach((member, index) => {
        formDataToSend.append(`username`, formData.username);
      // });

      // @ts-ignore
      const { response, message } = await Helper.Post({
        url: api_Routes.UserChat.StartChat,
        hasToken: true,
        data: formDataToSend as any,
      });

      if (response) {
        //

        onClose();
        console.log(response.data.conversation_id)
        setSelectedConversation(response.data.conversation_id)
        navigate(`/chats/individual/${response.data.type}/${response.data.chat_id}`);
        onGroupCreated();
      } else {
        setError(message || 'Failed to create group');
      }
    } catch (err) {
      setError('An error occurred while creating the group');
      console.error('Error creating group:', err);
    } finally {
      setLoading(false);

    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Start New Chat</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

            <TextField
                name="username"
                label="Username"
                value={formData.username}
                onChange={handleInputChange}
                required
                fullWidth
            />

            {error && (
              <Typography color="error" variant="body2">
                {error}
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            type="submit"
            variant="contained"
            disabled={ formData?.username === null}
          >
            {loading ? 'Starting...' : 'Start chat'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}; 